<template>
  <div id="app">

    <router-view />

  </div>
</template>
<script>
import UserService from './services/UserServices'
const userService = new UserService()

export default {
  mounted() {
    if (localStorage.getItem('token') !== null) {
      this.$store.dispatch('refreshUser')
    }
     
    this.$store.dispatch('loadFavouriteTutors')
  }
}
</script>